import React, { Component } from 'react';
import Modal from 'react-modal';
import {ProgressBar} from 'react-bootstrap';
import loadingAnimation from '../assets/images/loading.gif';
import loadingSandClock from '../assets/images/loading-sandwatch.gif';
import {clearInterval, setInterval} from "timers";

Modal.setAppElement('body');

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30%'
    }
};
class LoadingModal extends Component {

    constructor(props){
        super(props);
    }

    render() {
        return (
            <Modal isOpen={this.props.isUploading} style={customStyle}>
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="clearfix"> </div>
                        <img src={loadingSandClock} alt="Loading" className="ico-m"/>
                        <h4 className="modal-title">Saving...</h4>
                    </div>
                    <div className="modal-body">
                        {
                            this.props.timer && this.props.upTime ?
                                <h3>Done in {this.props.upTime.toString().split(".")[0]} seconds</h3>
                                :
                                null
                        }
                    </div>
                    <div className="modal-footer">
                    </div>
                </div>
            </Modal>
        );
    }
}

export default LoadingModal;



// WEBPACK FOOTER //
// ./src/LoadingModalComponent/LoadingModal.js